import * as React from 'react';
import { pluralize } from '@cian/newbuilding-utils';

interface IOffersCountProps {
  offersCount: number;
}

export const OffersCount = ({ offersCount }: IOffersCountProps) => {
  return <>{pluralize(offersCount, ['квартира', 'квартиры', 'квартир'])} в продаже</>;
};
